/** Geçerli kalıcı medya src'si mi (blob:/data: DB'ye yazılmaz). */
function isPersistedMediaSrc(src) {
  if (typeof src !== 'string') return false;
  const trimmed = src.trim();
  if (!trimmed) return false;
  if (trimmed.startsWith('blob:') || trimmed.startsWith('data:')) return false;
  return true;
}

/** ImageInput bazen tek dosyayı dizi olarak tutar. */
function normalizeImageField(value) {
  if (!value) return null;
  const item = Array.isArray(value) ? value[0] : value;
  if (!item || typeof item !== 'object') return null;
  if (!isPersistedMediaSrc(item.src) && !(item.rawFile instanceof Blob)) {
    return null;
  }
  const out = {};
  if (typeof item.src === 'string') out.src = item.src;
  if (item.title != null) out.title = item.title;
  if (item.rawFile instanceof Blob) out.rawFile = item.rawFile;
  return Object.keys(out).length ? out : null;
}

/** Panel/API hero kaydi — id ve specialEvents temizligi. */
export function sanitizeHeroRecord(record, requestedId) {
  const id = requestedId ?? record?.id ?? 'home';
  const next =
    record && typeof record === 'object' ? { ...record } : { specialEvents: [] };

  next.id = id;
  const legacyEvents = next.events;
  delete next.events;

  next.banner = normalizeImageField(next.banner);

  let specialEvents = Array.isArray(next.specialEvents) ? next.specialEvents : [];

  specialEvents = specialEvents
    .filter((entry) => entry && typeof entry === 'object')
    .map((entry) => {
      const row = {
        eventId: entry.eventId ?? entry.id ?? null,
        groupid: entry.groupid ?? null,
      };
      const featuredImage = normalizeImageField(entry.featuredImage);
      if (featuredImage) {
        row.featuredImage = featuredImage;
      }
      return row;
    })
    .filter((entry) => entry.eventId || entry.groupid);

  if (!specialEvents.length && legacyEvents && typeof legacyEvents === 'object') {
    specialEvents = Object.keys(legacyEvents)
      .filter((key) => /^event\d+$/.test(key))
      .sort(
        (a, b) =>
          Number(a.replace('event', '')) - Number(b.replace('event', '')),
      )
      .map((key) => legacyEvents[key])
      .filter((entry) => entry && typeof entry === 'object')
      .map((entry) => {
        const featuredImage = normalizeImageField(entry.featuredImage);
        return {
          eventId: entry.eventId ?? entry.id ?? null,
          groupid: entry.groupid ?? null,
          ...(featuredImage ? { featuredImage } : {}),
        };
      })
      .filter((entry) => entry.eventId || entry.groupid);
  }

  next.specialEvents = specialEvents;
  return next;
}

export function sanitizeHeroPayload(payload, requestedId) {
  if (!payload || typeof payload !== 'object') return payload;
  const next = sanitizeHeroRecord(payload, requestedId);
  delete next.events;
  delete next.createdby;
  delete next.updatedby;
  delete next.createdate;
  delete next.lastupdate;
  return next;
}
